module.exports = __webpack_public_path__ + "media/logo-clicksign-small.4dea2d92.svg";